import { mode, transparentize } from '@chakra-ui/theme-tools';

type Dict = Record<string, any>;

function solidBrandHeader(props: Dict) {
  const { colorScheme: c, theme } = props;
  const darkHoverBg = transparentize(`${c}.200`, 0.12)(theme);

  return {
    color: mode(`white`, `${c}.200`)(props),
    bg: mode(`brand.500`, `gray.300`)(props),
    borderRadius: `lg`,
    _hover: {
      bg: mode(`#90dcd5`, darkHoverBg)(props),
    },
  };
}

function solidBrandCTA(props: Dict) {
  const { colorScheme: c, theme } = props;
  const darkHoverBg = transparentize(`${c}.200`, 0.12)(theme);

  return {
    color: mode(`white`, `${c}.200`)(props),
    bg: mode(`brand.500`, `gray.300`)(props),
    borderRadius: `lg`,
    _hover: {
      bg: mode(`#f0f0f0`, darkHoverBg)(props),
      color: mode(`brand.500`, `${c}.500`)(props),
    },
  };
}
const variants = {
  'solid-brand-header': solidBrandHeader,
  'solid-brand-cta': solidBrandCTA,
};

export default {
  variants,
};
